import { connect } from 'react-redux';
import { getIsMobile, getEmployerId, getTemplatesByOrg } from '../../modules/Settings';
import { getMapView, getViewType, getExperiments, getPrimaryColor, getSecondaryColor, getNoAds } from '../../modules/Filters';
import { get as getI18n } from '../../modules/I18n';
import { getPageTitle, getPageDescription } from '../../modules/Seo';
import { getLoading, getTakeover, fetchJobsClient } from '../../modules/JobsList';
import { withRouter } from 'react-router-dom';
import App from './App';

const mapStateToProps = state => ({
  isMobile: getIsMobile(state),
  mapView: getMapView(state),
  i18n: getI18n(state),
  loading: getLoading(state),
  takeover: getTakeover(state),
  viewType: getViewType(state),
  pageTitle: getPageTitle(state),
  pageDescription: getPageDescription(state),
  experiments: getExperiments(state),
  employerId: getEmployerId(state),
  templatesByOrg: getTemplatesByOrg(state),
  primaryColor: getPrimaryColor(state),
  secondaryColor: getSecondaryColor(state),
  noAds: getNoAds(state),
});

const mapDispatchToProps = dispatch => ({
  changedHistory: (() => {
    const lastCall = {};
    return ({ search, state }) => {
      if (typeof state === 'undefined' || !state.notScroll) {
        window && window.scrollTo(0, 0);
      }
      const seokey = window.location.pathname.replace(/(\/en-(au|gb))?(\/jobs\/(search|browse)(\/embed(\/[0-9]*)?)?(\?|\/)?)/i, '');
      if (lastCall.search === search && lastCall.seokey === seokey) return;
      lastCall.search = search;
      lastCall.seokey = seokey;
      dispatch(fetchJobsClient({ search, seokey: encodeURIComponent(seokey) }));
    };
  })()
});

const AppContainer = connect(mapStateToProps, mapDispatchToProps)(App);

export default withRouter(AppContainer);
